import React from 'react';
import { Cita } from '../../services/citasService';

export default function ProductosReservaDetalle({ cita, showEmpty = false }: { cita: Cita; showEmpty?: boolean }) {
  if (!cita.productos_reserva?.length) return showEmpty ? <section className="my-4 rounded-xl border border-slate-200 bg-white p-5">
    <h3 className="font-bold text-[#007FC8]">Cafetería</h3>
    <p className="mt-2 text-sm text-slate-500">Esta reserva no incluye productos de cafetería.</p>
  </section> : null;
  return <section className="my-4 rounded-xl border border-slate-200 bg-white p-5">
    <h3 className="font-bold mb-3 text-[#007FC8]">Productos de cafetería</h3>
    <div className="overflow-x-auto"><table className="w-full text-sm">
      <thead><tr><th className="text-left">Producto</th><th>Cantidad</th><th>Precio Bs</th><th>Subtotal Bs</th></tr></thead>
      <tbody>{cita.productos_reserva.map(p => <tr key={p.id}>
        <td className="py-2">{p.nombre}</td><td className="text-center">{p.cantidad}</td>
        <td className="text-right">{Number(p.precio_unitario).toFixed(2)}</td>
        <td className="text-right">{Number(p.subtotal).toFixed(2)}</td>
      </tr>)}</tbody>
    </table></div>
    <p className="text-right font-bold mt-2">Total productos: Bs {Number(cita.total_productos || 0).toFixed(2)}</p>
  </section>;
}
